import { type FC } from 'react';
import ExpandableFilterPanel from 'components/molecules/expandable-filter-panel';
import { useUntrackedInboundCallsFilters } from 'infrastructure/hooks/untrackedInboundCalls/useFilters';

import Body from './body';
import s from './styles.module.scss';

const UntrackedInboundCallsFilters: FC = () => {
  const { count, resetFilter } = useUntrackedInboundCallsFilters();
  return (
    <div className={s.wrapper}>
      <ExpandableFilterPanel filtersCount={count} onReset={resetFilter}>
        <Body />
      </ExpandableFilterPanel>
    </div>
  );
};

export default UntrackedInboundCallsFilters;
